import { Modal } from 'bootstrap';
import 'gasparesganga-jquery-loading-overlay';

(function () {
  const RealPageSubscriptions = {
    init() {
      this.container = document.querySelector('[data-real-page-subscriptions]');
      if (!this.container) return;

      this.fetchUrl = this.container.dataset.fetchUrl;
      this.updateUrl = this.container.dataset.updateUrl;
      this.currentStatus = this.container.dataset.defaultStatus;
      this.loadingLogo = this.container.dataset.loadingLogo;
      this.currentFilter = '';
      this.tableElement = $('#real-page-subscriptions-table');
      this.alertElement = document.getElementById('real-page-subscriptions-alert');
      this.modalElement = $('#subscription-modal');
      this.modalDialogEl = document.getElementById('subscription-modal');
      this.modalInstance = this.modalDialogEl ? new Modal(this.modalDialogEl) : null;
      this.modal = {
        propertyName: document.getElementById('subscription-property-name'),
        propertyId: document.getElementById('subscription-property-id'),
        companyName: document.getElementById('subscription-company-name'),
        companyId: document.getElementById('subscription-company-id'),
        statusSelect: document.getElementById('subscription-status-select'),
        error: document.getElementById('subscription-modal-error'),
        saveButton: this.modalElement.find('[data-action="save-subscription"]'),
      };

      this.bindEvents();
      this.buildLoadingOverlayOptions();
      this.loadingOverlayAvailable = typeof $.LoadingOverlay === 'function';
      this.fetchAndRender(this.currentStatus, { force: true });
    },

    bindEvents() {
      this.bindTabs();
      this.bindModal();
    },

    bindTabs() {
      this.tabs = Array.from(this.container.querySelectorAll('[data-status-tab]'));

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', (event) => {
          event.preventDefault();
          const { statusTab } = tab.dataset;
          this.fetchAndRender(statusTab, { force: true });
        });
      });
    },

    bindModal() {
      this.tableElement.on('click', '[data-action="edit-subscription"]', (event) => {
        event.preventDefault();
        const rowData = this.table
          .row($(event.currentTarget).closest('tr'))
          .data();
        this.openModal(rowData);
      });

      this.modal.saveButton.on('click', () => this.saveSubscription());
      this.modalDialogEl.addEventListener('hidden.bs.modal', () => {
        this.activeSubscription = null;
        this.toggleModalError();
      });
    },

    fetchAndRender(status, { force = false } = {}) {
      if (!force && !status) return;

      this.setActiveStatus(status);
      this.showLoading();

      const url = new URL(this.fetchUrl, window.location.origin);
      url.searchParams.set('status', status);

      fetch(url.toString(), {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      })
        .then((response) =>
          response
            .json()
            .catch(() => ({}))
            .then((body) => {
              if (!response.ok) {
                const error = body.error || 'Unable to load subscriptions.';
                throw new Error(error);
              }
              return body;
            })
        )
        .then((data) => {
          this.toggleAlert(data.message);
          this.renderTable(data.subscriptions || []);
          this.applyFilter();
        })
        .catch((error) => {
          alert(error.message);
        })
        .finally(() => this.hideLoading());
    },

    setActiveStatus(status) {
      this.currentStatus = status;
      this.tabs.forEach((tab) => {
        tab.classList.toggle('active', tab.dataset.statusTab === status);
      });
    },

    renderTable(subscriptions) {
      const tableData = subscriptions.map((subscription) => ({
        property_name: subscription.property_name || '',
        property_id: subscription.property_id || '',
        company_name: subscription.company_name || '',
        company_id: subscription.company_id || '',
        subscription_status: subscription.subscription_status || '',
        subscription_id: subscription.subscription_id,
      }));

      if (!this.table) {
        this.table = this.tableElement.DataTable({
          data: tableData,
          autoWidth: false,
          pageLength: 20,
          columns: [
            { data: 'property_name', title: 'Property name', defaultContent: '' },
            { data: 'property_id', title: 'Property ID', defaultContent: '' },
            { data: 'company_name', title: 'Company', defaultContent: '' },
            { data: 'company_id', title: 'Company ID', defaultContent: '' },
            { data: 'subscription_status', title: 'Subscription status', defaultContent: '' },
            {
              data: null,
              title: 'Action',
              orderable: false,
              searchable: false,
              className: 'text-center',
              defaultContent: '',
              render: () => (
                '<button type="button" class="btn btn-link p-0" data-action="edit-subscription">' +
                '<i class="fas fa-pen"></i>' +
                '</button>'
              ),
            },
          ],
          layout: {
            topStart: 'buttons',
            topEnd: {
              search: {
                text: '',
                placeholder: 'Search subscription...',
              },
            },
            bottomStart: 'info',
            bottomEnd: {
              paging: {
                buttons: 5,
                type: 'full_numbers',
              },
            },
          },
          buttons: [
            {
              extend: 'csv',
              text: '<i class="far fa-save"></i> Download CSV',
              className: 'button-secondary__active fetch-file-button',
            },
          ],
        });

        this.table.on('search.dt', () => {
          this.currentFilter = this.table.search();
        });
      } else {
        this.table.clear();
        this.table.rows.add(tableData);
        this.table.draw();
      }
    },

    teardown() {
      this.currentFilter = this.table ? this.table.search() : '';
      if (this.table) {
        this.table.destroy(true);
        this.table = null;
      }
      this.tableElement.off('click', '[data-action="edit-subscription"]');
      this.modalElement.off('hidden.bs.modal');
    },

    applyFilter() {
      if (!this.table) return;
      const filterValue = this.currentFilter || '';
      if (this.table.search() === filterValue) return;
      this.table.search(filterValue).draw();
    },

    openModal(subscription) {
      this.activeSubscription = subscription;
      this.modal.propertyName.textContent = subscription.property_name || '—';
      this.modal.propertyId.textContent = subscription.property_id || '—';
      this.modal.companyName.textContent = subscription.company_name || '—';
      this.modal.companyId.textContent = subscription.company_id || '—';
      this.modal.statusSelect.value = subscription.subscription_status || '';
      this.toggleModalError();
      if (this.modalInstance) this.modalInstance.show();
    },

    saveSubscription() {
      if (!this.activeSubscription) return;

      const newStatus = this.modal.statusSelect.value;
      if (!newStatus) {
        this.showModalError('Select a subscription status to continue.');
        return;
      }

      if (newStatus === this.activeSubscription.subscription_status) {
        this.modalElement.modal('hide');
        return;
      }

      this.setModalLoading(true);

      fetch(this.updateUrl, {
        method: 'PATCH',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
        },
        body: JSON.stringify({
          real_page_subscription: {
            subscription_id: this.activeSubscription.subscription_id,
            pmc_id: this.activeSubscription.company_id,
            site_id: this.activeSubscription.property_id,
            new_status: newStatus,
          },
        }),
      })
        .then((response) =>
          response
            .json()
            .catch(() => ({}))
            .then((body) => {
              if (!response.ok) {
                const error = body.error || 'Unable to update subscription.';
                throw new Error(error);
              }
              return body;
            })
        )
        .then(() => {
          if (this.modalInstance) this.modalInstance.hide();
          this.fetchAndRender(newStatus, { force: true });
        })
        .catch((error) => this.showModalError(error.message))
        .finally(() => this.setModalLoading(false));
    },

    setModalLoading(isLoading) {
      this.modal.saveButton.prop('disabled', isLoading);
      this.modal.statusSelect.disabled = isLoading;
    },

    toggleAlert(message) {
      if (!this.alertElement) return;
      if (message) {
        this.alertElement.textContent = message;
        this.alertElement.classList.remove('d-none');
      } else {
        this.alertElement.textContent = '';
        this.alertElement.classList.add('d-none');
      }
    },

    toggleModalError(message) {
      if (!this.modal.error) return;
      if (message) {
        this.modal.error.textContent = message;
        this.modal.error.classList.remove('d-none');
      } else {
        this.modal.error.textContent = '';
        this.modal.error.classList.add('d-none');
      }
    },

    showModalError(message) {
      this.toggleModalError(message);
    },

    buildLoadingOverlayOptions() {
      this.loadingOverlayOptions = {
        background: 'rgba(0, 0, 0, 0.8)',
        image: '',
        text: '',
        custom: `<div class='real-page-loading-content'><div class='rotating-bmx-logo'><img src='${this.loadingLogo}' alt='ButterflyMX logo'></div></div>`,
      };
    },

    showLoading() {
      if (this.loadingOverlayAvailable) {
        $.LoadingOverlay('show', this.loadingOverlayOptions);
      }
    },

    hideLoading() {
      if (this.loadingOverlayAvailable) {
        $.LoadingOverlay('hide');
      }
    },
  };

  window.RealPageSubscriptions = RealPageSubscriptions;
  document.addEventListener('turbo:before-cache', () => {
    if (RealPageSubscriptions.container) RealPageSubscriptions.teardown();
  });

  document.addEventListener('turbo:load', () => RealPageSubscriptions.init());
})();
